// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import * as Markdown from '../../../components/Markdown';
import styled from 'styled-components';

interface CollapseMarkdownProps extends React.ComponentPropsWithRef<'div'> {
  markdown: string;
  baseUrl?: string;
  imgUrl?: string;
}

const CollapseMarkdown = (props: CollapseMarkdownProps): JSX.Element => {
  const {
    markdown,
    baseUrl,
    imgUrl
  } = props;

  const breaklineIndex = markdown.indexOf('\n') !== -1 ? markdown.indexOf('\n') : markdown.length;
  const contentMarkdown = markdown.slice(breaklineIndex + 1);

  return (
    <>
      <Markdown.HintMarkdown imgUrl={imgUrl} baseUrl={baseUrl} markdown={contentMarkdown}/>
    </>
  )
}

const S = {
  CollapseMarkdown: styled(CollapseMarkdown)`
    & {
      margin-top: 24px;
      border-top: 2px solid #DEDEDE;
      padding-top: 24px;

      button {
        top: 24px;
      }
    }
  `,
}

interface ChallengeMarkdownProps extends React.ComponentProps<'div'> {
  markdowns: string[];
  baseUrl?: string;
  imgUrl?: string;
}

const ChallengeMarkdown = (props: ChallengeMarkdownProps): JSX.Element => {
  const {
    markdowns,
    baseUrl,
    imgUrl
  } = props;

  return (
    <>{markdowns.map((markdown, index) =>
      <S.CollapseMarkdown
        key={index}
        markdown={markdown}
        imgUrl={imgUrl}
        baseUrl={baseUrl}
      />)
    }
    </>
  )
}

export default ChallengeMarkdown;
